import CabeceraPagina from './CabeceraPagina.jsx';
import limpiarHtml from './limpiarHtml.js';

// Pàgina de text llarg de la BBDD (Legal, Termes, Cookies, Clients...):
// capçalera i el text en una caixa blanca, com els textos legals del disseny.
const PaginaTexto = ({ titulo, eyebrow, imagen, logo, html }) => (
    <>
        <CabeceraPagina titulo={titulo} eyebrow={eyebrow} imagen={imagen} logo={logo} />
        <div className="hc">
            <section className="o-container hc-text">
                <div className="hc-text__content hc-text__content--padding" dangerouslySetInnerHTML={{ __html: limpiarHtml(html) }}></div>
            </section>
        </div>
    </>
);

export default PaginaTexto;
